import Backbone from 'backbone';
import M from 'backbone.marionette'
import { AdminPunchReports } from './adminpunchreports';
import { AdminPunchList } from './adminpunchlist';
import T from './admin.html'
import Radio from 'backbone.radio';
import { minutesToTimeString } from '../../utils/utils';

export const PunchAdmin = M.View.extend({
    template: _.template(T),

    punches: null,
    punchreports: null,
    enseignant: null,
    punchTypes: null,
    user: null,

    regions: {
        'punchreports': {
            el: '.punchReportsContainer'
        },
        'punches':{
            el: '.punchesContainer'
        }
    },
    initialize: function(){

        var initialData = this.$el.text();

        this.$el.text('');

        const data = JSON.parse(atob(initialData));
        this.initializeWidthData(data);
        

        Radio.channel('punch').on('save', this.onPunchSave, this);
        Radio.channel('punch').on('generateReport', this.onGenerateReportClick, this);
        Radio.channel('punch').on('loadPunches', this.onLoadPunches, this);
    },
    initializeWidthData: function(data){
        
        this.punches = new Backbone.Collection(data.punches);
        this.punchreports = new Backbone.Collection(data.punchreports);
        this.enseignant = new Backbone.Collection(data.enseignant);
        this.user = new Backbone.Model(data.user);
        this.punchTypes = new Backbone.Collection(data.punchTypes.map(p => {
            return {id: p, label: p, value: p}
        }));
        if(this.model){
            this.model.set({
                punches: this.punches.clone(),
                enseignant: this.enseignant.clone(),
                user: this.user,
                punchTypes: this.punchTypes
            });
        }else{
            this.model = new Backbone.Model({
                punchreport_id: null,
                punches: this.punches.clone(),
                enseignant: this.enseignant.clone(),
                user: this.user,
                filterPunch: 1, // 1 = tous, 2 à valider seulement
                loadedPunchReports: new Backbone.Collection(),
                punchTypes: this.punchTypes
            });
        }
        
        this.updateQuatities();
    },
    onDestroy: function(){
        Radio.channel('punch').off('save', this.onPunchSave, this);
        Radio.channel('punch').off('generateReport', this.onGenerateReportClick, this);
        Radio.channel('punch').off('loadPunches', this.onLoadPunches, this);
    },
    updateQuatities: function(){
        const nonTraites = this.punches.filter(p => !p.get('punchreport_id'))
        this.model.set({
            nbNonTraites: nonTraites.length,
            minNonTraites: minutesToTimeString(nonTraites.reduce((acc, curr) => { return acc + (curr.get('punchTimeInMinutes') ?? 0)}, 0)),
        })
    },
    
    onPunchSave: function(model){
        this.punches.add(model, {merge: true});
        this.model.get('punches').add(model, {merge: true});
        this.updateQuatities();
        this.render();
    },
    onRender: function(){
        
        this.showChildView('punchreports', new AdminPunchReports({
            model: this.model,
            punchreports: this.punchreports,
            punches: this.punches
        }));
        this.showChildView('punches', new AdminPunchList({
            model: this.model,
            punchreports: this.punchreports,
            punches: this.punches
        }))
    },
    onGenerateReportClick: function(){
        if(this.model.get('nbValides')){
            if(confirm('Produire le rapport de ' + this.model.get('nbValides') + ' feuille(s) de temps validée(s) ?')){
                $.ajax({
                    url: './api/specialiste/genererrapportdetemps',
                    type: 'post',
                    data: {
                        data: JSON.stringify(true),
                    },
                    success: this.onGenerateReportSuccess.bind(this),
                    error: (xhr) => {
                        alert('Une erreur a eu lieu');
                    }
                });
            }
        }else{
            alert('Le rapport ne contient aucun temps validé.')
        }
    },
    onGenerateReportSuccess: function(data){
        this.initializeWidthData(data);
        this.render();
    },
    onLoadPunches: function(punchReportId){
        const punchreport = this.punchreports.get(punchReportId);
        if(punchreport){
            if(this.model.get('loadedPunchReports').get(punchReportId)){
                // déjà chargé !
                this.model.set({
                    punchreport_id: punchReportId
                });
                this.render();
            }else{
                $.ajax({
                    url: './api/specialiste/punchdata/'+punchReportId,
                    type: 'get',
                    success: this.onLoadPunchesSuccess.bind(this),
                    error: (xhr) => {
                        alert('Une erreur a eu lieu');
                    }
                });
                this.model.set({
                    punchreport_id: punchReportId
                })
            }
        }else{
            this.model.set({
                punchreport_id: punchReportId
            });
            this.render();
        }
    },
    onLoadPunchesSuccess: function(response){
        if(response.punchreport_id)this.model.get('loadedPunchReports').add({id: response.punchreport_id});
        this.onGenerateReportSuccess(response);
        this.render();
    }
    
})